export class ThemeManager {
  private static readonly THEMES = ['divas', 'chads'];
  private static readonly DEFAULT_THEME = 'divas';
  private static readonly THEME_STORAGE_KEY = 'site_type';

  private static selectedTheme = ref<string>('');

  public getThemeRef() {
    return ThemeManager.selectedTheme;
  }

  public getTheme() {
    return ThemeManager.selectedTheme.value || ThemeManager.DEFAULT_THEME;
  }

  public static setCSSTheme(theme: string) {
    if (!theme) theme = ThemeManager.DEFAULT_THEME;
  
    const cssClasses = document.body.classList;
  
    for (const theme of ThemeManager.THEMES) {
      if (cssClasses.contains(theme)) {
        cssClasses.remove(theme);
      }
    }
  
    cssClasses.add(theme);
  }

  public static loadTheme() {
    const theme = localStorage.getItem(ThemeManager.THEME_STORAGE_KEY);
    ThemeManager.setTheme(theme);
  }

  public static setTheme(theme: string | null) {
    if (!theme) theme = '';

    ThemeManager.setCSSTheme(theme);
    localStorage.setItem(ThemeManager.THEME_STORAGE_KEY, theme);
    ThemeManager.selectedTheme.value = theme;
  }

  public isChadsTheme() {
    return this.getTheme() === 'chads';
  }

  public isDivasTheme() {
    return this.getTheme() === 'divas';
  }

  public changeBySex(sex: string) {
    switch (sex) {
      case 'M': {
        ThemeManager.setTheme('chads');
        break;
      }
      case 'F': {
        ThemeManager.setTheme('divas');
        break;
      }
      case 'X': break;
    }
  }
}

export default defineNuxtPlugin(() => {
  ThemeManager.loadTheme();

  return {
    provide: {
      ThemeManager: new ThemeManager(),
    },
  };
});
